import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar1 from "./components/Navbar";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import AboutMe from "./pages/AboutMe";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import './App.css';

function App() {
  return (
    <div style={{ backgroundColor: '#000000'}}>
      <Router>
        <Navbar1 />
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/aboutme" element={<AboutMe />} />
            <Route path="/testimonial" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>
        <Footer />  {/* Footer Added Here */}
      </Router>
    </div>
  );
}

export default App;
